import Vue from 'vue'
import Vuex, { Playload, Store} from 'vuex'
import VuePersist from 'vuex-persist'
import menu from '@/pages/layout/menu';

import {filterMenu} from '@/utils/util';
Vue.use(Vuex)

/**
 * store数据本地持久化
 */
const vuexLocal = new VuePersist({
    key: 'vuexbase',
    storage: window.localStorage,
    reducer: (state) => {
        return {    
            token: state.token,
            userInfo: state.userInfo,
            authExpires: state.authExpires,
            dontShowAuthExpires: state.dontShowAuthExpires,
        }
    }
})

export default new Vuex.Store({
	state: {
		isCollapse: false, // 菜单栏缩放状态
        hasMenu: false, // 是否加入动态路由
        menuList: [], // 菜单栏列表数据
        token: '', // token
        userInfo: {},
        authExpires: '',
        dontShowAuthExpires: false
	},
	mutations: {
        updateUserInfo(state, data) {
            state.userInfo = data
        },
		updateCollapse(state, data) {
			state.isCollapse = data
		},
        updateMenuList(state, data) {
            state.menuList = data
        },
        updateToken(state, data) {
            if (!data) return
            state.token = data
        },
        updateHasMenu(state, flag) {
            state.hasMenu = flag 
        },
        updateAuthExpires(state, time) {
            state.authExpires = time 
        },
        hideAuthExpires(state, status) {
            state.dontShowAuthExpires = status 
        }
	},
	actions: {
        getMenu({commit}, data) {
            return new Promise((resolve, reject) => {
                commit('updateMenuList', filterMenu(menu || []))
                resolve()
                // getMenuList().then(res => {
                    
                //     commit('updateMenuList', filterMenu(res.data || []))
                //     resolve()
                // }).catch((err) => {
                //     reject(err)
                // })
            })
        }
	},
    plugins: [vuexLocal.plugin]
})
